// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_l0W","cls2":"ReferenceCard-cls2_r-1 ReferenceCard-cls1_l0W"};